import { canAccessGptClassic, canAccessOpenAIAssistant, canAccessRagFlowAssistant } from '../../utils/adminMenu';

const ADMIN_SHARED_MENU_ITEMS = [
  { id: 'resumen', label: 'Dashboard', icon: 'fas fa-chart-line' },
  { id: 'procesos', label: 'Procesos', icon: 'fas fa-tasks' },
  { id: 'profesores', label: 'Profesores', icon: 'fas fa-chalkboard-teacher' },
  { id: 'areas', label: 'Areas', icon: 'fas fa-sitemap' },
  { id: 'admin-area', label: 'Admins de area', icon: 'fas fa-user-tie' },
  { id: 'materias', label: 'Materias', icon: 'fas fa-book' },
  { id: 'asistentes', label: 'Asistentes OpenAI', icon: 'fas fa-robot' },
  { id: 'asistentes-ragflow', label: 'Asistentes AVE', icon: 'fas fa-robot' },
  { id: 'asistentes-gpt', label: 'Asistentes GPT', icon: 'fas fa-robot' },
  { id: 'reportes', label: 'Reportes', icon: 'fas fa-chart-bar' }
];

const PROFESSOR_SHARED_MENU_ITEMS = [
  { id: 'dashboard', label: 'Dashboard', icon: 'fas fa-tachometer-alt' },
  { id: 'procesos', label: 'Procesos', icon: 'fas fa-tasks' },
  { id: 'mis-asistentes', label: 'Asistentes OpenAI', icon: 'fas fa-list-ul' },
  { id: 'mis-ragflow-asistentes', label: 'Asistentes AVE', icon: 'fas fa-robot' },
  { id: 'asistentes-gpt', label: 'Asistentes GPT', icon: 'fas fa-robot' },
  { id: 'reportes', label: 'Reportes', icon: 'fas fa-chart-bar' }
];

const mergeMenuItems = (baseItems, extraItems = []) => {
  const merged = [...baseItems];

  extraItems
    .filter(Boolean)
    .forEach((item) => {
      if (!item.id || merged.some((currentItem) => currentItem.id === item.id)) {
        return;
      }

      const insertAfterIndex = item.insertAfterId
        ? merged.findIndex((currentItem) => currentItem.id === item.insertAfterId)
        : -1;

      if (insertAfterIndex >= 0) {
        merged.splice(insertAfterIndex + 1, 0, item);
      } else {
        merged.push(item);
      }
    });

  return merged;
};

const filterFeatureMenuItems = (items, { user, isGptClassicEnabled, isOpenAIAssistantEnabled, isRagFlowAssistantEnabled }) =>
  items.filter((item) => {
    if (item.id === 'asistentes-gpt' || item.id === 'nuevo-gpt') {
      return canAccessGptClassic(user, isGptClassicEnabled);
    }
    if (item.id === 'asistentes' || item.id === 'mis-asistentes' || item.id === 'nuevo-asistente') {
      return canAccessOpenAIAssistant(user, isOpenAIAssistantEnabled);
    }
    if (item.id === 'asistentes-ragflow' || item.id === 'mis-ragflow-asistentes' || item.id === 'nuevo-ragflow-asistente') {
      return canAccessRagFlowAssistant(user, isRagFlowAssistantEnabled);
    }
    return true;
  });

const getAdminMenuItems = ({ user, isGptClassicEnabled, isOpenAIAssistantEnabled = true, isRagFlowAssistantEnabled = false, extraItems = [] } = {}) =>
  filterFeatureMenuItems(mergeMenuItems(ADMIN_SHARED_MENU_ITEMS, extraItems), { user, isGptClassicEnabled, isOpenAIAssistantEnabled, isRagFlowAssistantEnabled });

const getProfessorMenuItems = ({ user, isGptClassicEnabled, isOpenAIAssistantEnabled, isRagFlowAssistantEnabled, extraItems = [] } = {}) =>
  filterFeatureMenuItems(mergeMenuItems(PROFESSOR_SHARED_MENU_ITEMS, extraItems), { user, isGptClassicEnabled, isOpenAIAssistantEnabled, isRagFlowAssistantEnabled });

const navigateAdminMenuItem = (navigate, itemId) => {
  if (!itemId) return;
  if (itemId === 'asistentes-gpt') {
    navigate('/gpt-assistants');
    return;
  }
  if (itemId === 'reportes') {
    navigate('/reports');
    return;
  }
  if (itemId === 'procesos') {
    navigate('/procesos');
    return;
  }
  navigate('/admin-dashboard', { state: { tab: itemId } });
};

const navigateProfessorMenuItem = (navigate, itemId) => {
  const routesByMenuId = {
    dashboard: '/dashboard',
    'mis-asistentes': '/my-assistants',
    'mis-ragflow-asistentes': '/ragflow-assistants',
    'asistentes-gpt': '/gpt-assistants',
    reportes: '/reports',
    procesos: '/procesos',
    'nuevo-asistente': '/new-assistant',
    'nuevo-ragflow-asistente': '/new-ragflow-assistant',
    'nuevo-gpt': '/new-gpt-assistant'
  };

  const targetRoute = routesByMenuId[itemId];
  if (targetRoute) {
    navigate(targetRoute);
  }
};

const NEW_ASSISTANT_MENU_ITEM = {
  id: 'nuevo-asistente',
  label: 'Nuevo Asistente',
  icon: 'fas fa-plus',
  insertAfterId: 'dashboard'
};

const NEW_RAGFLOW_ASSISTANT_MENU_ITEM = {
  id: 'nuevo-ragflow-asistente',
  label: 'Nuevo AVE',
  icon: 'fas fa-plus',
  insertAfterId: 'dashboard'
};

const NEW_GPT_MENU_ITEM = {
  id: 'nuevo-gpt',
  label: 'Nuevo GPT Clasico',
  icon: 'fas fa-plus',
  insertAfterId: 'dashboard'
};

export {
  ADMIN_SHARED_MENU_ITEMS,
  getAdminMenuItems,
  getProfessorMenuItems,
  navigateAdminMenuItem,
  navigateProfessorMenuItem,
  NEW_ASSISTANT_MENU_ITEM,
  NEW_RAGFLOW_ASSISTANT_MENU_ITEM,
  NEW_GPT_MENU_ITEM
};
